import { SessionPermission } from "../../types/session-permission";

export const PERMISSIONS: Record<string, SessionPermission[]> = {
  USER: [
    SessionPermission.VIEW_QUICKSCAN,
    SessionPermission.CREATE_PROJECTS,
    SessionPermission.POWERBI_REPORT,
    SessionPermission.VIEW_QUICKSCANS,
    SessionPermission.VIEW_SUCCESS,
  ],
  MANAGER: [
    SessionPermission.VIEW_QUICKSCAN,
    SessionPermission.CREATE_PROJECTS,
    SessionPermission.POWERBI_REPORT,
    SessionPermission.VIEW_QUICKSCANS,
    SessionPermission.VIEW_SUCCESS,
  ],
};
